import React, { Component, ComponentType, ReactNode } from 'react';
import Config from '../../config';
import setToast from '../../helpers/toaster.helper';
import { EmailService } from "../../services/email.service";
import { ToasterType } from './toaster/toaster.model';
// import { faro } from '@grafana/faro-web-sdk';

interface IState {
    HasError: boolean;
}

interface ErrorHandlerProps {
    ModuleName: string;
    children: ReactNode;
}

export class ErrorHandler extends Component<ErrorHandlerProps, IState> {
    constructor(props: ErrorHandlerProps) {
        super(props);
    }

    static getDerivedStateFromError(error: any) {
        // Update state so the next render will show the fallback UI.
        return { HasError: true };
    }

    componentDidCatch(error: any, errorInfo: any) {
        if (Config.IS_PROD_ENV || Config.IS_BETA_ENV || Config.IS_UAT_ENV) {
            const userEmail =
                localStorage.getItem("current-user") !== null
                    ? JSON.parse(localStorage.getItem("current-user")?.toString())?.email
                    : "";
            EmailService.sendEmailToIssueReportTeam([{ Email: Config.ISSUE_REPORT_EMAIL }], {
                ModuleName: this.props.ModuleName,
                Error:
                    `Module: ${this.props.ModuleName}` +
                    `${userEmail ? `\r\n for User ::${userEmail}` : ""}` +
                    `\r\n${error}` +
                    `\r\n${JSON.stringify(errorInfo)}`,
            });
            // push error manually
            // faro.api.pushError(new Error(error + "\r\n" + JSON.stringify(errorInfo)));
        }
        setToast("Something went wrong, reporting issue to tech team", ToasterType.DANGER)
    }


    render() {
        return this.props.children;
    }
}


export function withErrorBoundaries(Component: ComponentType | ComponentType<any>, ModuleName: string) {
    return class extends React.Component {

        render() {
            return <ErrorHandler ModuleName={ModuleName}>
                <Component {...this.props} />
            </ErrorHandler>
        }
    }
}
